import React from "react";
import ExperienceDetails from "./ExperienceDetails";
import { Work_Experience } from "../../data/WorkExperienceData";
import { Education } from "../../data/EducationData";
// import { Volunteer_Experience } from "../../data/VolunteerExperienceData";
import "./Experiences.css";


const resumeData = {
  Work_Experience,
  Education,
  // Volunteer_Experience
};

function Experiences(props) {
  let resumeTopic = resumeData[props.heading];

  return (
    <div className="one-second-animation">
      <h2 className="h2">{props.heading.replace("_"," ")}</h2>

      {resumeTopic.map((data, index) => (
        <ExperienceDetails 
          key={index}
          heading={data.designation}
          name={data.name}
          duration={data.duration}
          info={data.info}
          gitLink={data.gitLink || ""}
        />
      ))}

    </div>
  );
}

export default Experiences;